<p-dialog
  ngSkipHydration
  [(visible)]="visible"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [closeOnEscape]="true"
  [dismissableMask]="true"
  [focusOnShow]="false"
  styleClass="w-[90vw] max-w-[800px] h-[90vh] lg:w-[50vw] md:w-[65vw] sm:w-[75vw] w-[90vw]"
  contentStyleClass="rounded-3xl overflow-hidden p-0"
  [blockScroll]="true">

  <ng-template #headless>
    <div class="flex flex-col justify-between bg-white rounded-2xl overflow-hidden h-full">
      <div
        class="h-[30%] relative w-full overflow-hidden bg-gradient-to-br from-slate-100 to-slate-500">
        <img
          [src]="getImageUrl(carData().id, carData().offerGallery[0].fileId)"
          [alt]="carData().name"
          class="w-full h-full object-cover"
        />

        <div
          class="absolute bottom-0 left-0 right-0 p-6 bg-gradient-to-t from-black/100 to-transparent flex flex-col justify-end">
          <h2 class="text-2xl font-secondary font-semibold text-secondary-200 mb-2">{{ carData().name }}</h2>

          <div class="w-full inline-flex items-center justify-start gap-2">

            <div class="inline-flex items-center gap-2 backdrop-blur-sm px-3 py-1.5 rounded-full w-fit"
                 [ngClass]="carData().offerEndingInfo.accent">
              <ng-icon name="tablerClock" size="1rem"></ng-icon>
              <span class="text-sm font-semibold">
                {{ carData().offerEndingInfo.daysLeft }}
              </span>
            </div>

            <div
              class="inline-flex items-center gap-2 backdrop-blur-sm px-3 py-1.5 rounded-full w-fit bg-emerald-300 text-emerald-800">
              <ng-icon name="tablerCashBanknote" size="1rem"></ng-icon>
              <span class="text-sm font-semibold">
                {{ carData().installment }} zł/mc
              </span>
            </div>

          </div>
        </div>
        <p-button
          [rounded]="true"
          icon="pi pi-times"
          severity="secondary"
          size="small"
          styleClass="absolute top-3 right-3"
          (click)="onClose()">
        </p-button>
      </div>

      <div class="p-8 md:p-10 overflow-y-auto flex-1 flex flex-col items-center justify-start">
        <p-message
          severity="info"
          icon="pi pi-info-circle"
          text="Zostaw swoje dane, a nasz doradca skontaktuje się z Tobą w ciągu 24h"
          styleClass="text-center w-fit mb-8"
          size="small"
        />

        <form
          [formGroup]="offerForm"
          class="flex flex-col gap-6 w-full"
        >

          <div class="flex flex-col w-full">
            <p-floatlabel>
              <input
                pInputText
                id="fullName"
                [formControl]="offerForm.controls.fullName"
                [invalid]="isInvalid('fullName')"
                class="w-full"
              />
              <label for="fullName">Imię i nazwisko</label>
            </p-floatlabel>

            @if (isError('fullName'); as error) {
              <p-message severity="error" size="small" variant="simple" class="mt-2 ml-2">
                {{ error }}
              </p-message>
            }

            @if (!offerForm.controls.fullName.touched || offerForm.controls.fullName.valid) {
              <small class="mt-2 ml-2 text-secondary-800" id="fullName-help">To pole jest wymagane</small>
            }
          </div>

          <!-- Company -->
          <div class="flex flex-col w-full">
            <p-floatlabel>
              <input
                pInputText
                id="company"
                [formControl]="offerForm.controls.company"
                [invalid]="isInvalid('company')"
                class="w-full"
              />
              <label for="company">Firma</label>
            </p-floatlabel>

            @if (isError('company'); as error) {
              <p-message severity="error" size="small" variant="simple" class="mt-2 ml-2">
                {{ error }}
              </p-message>
            }
          </div>

          <div class="flex flex-col w-full">
            <p-floatlabel>
              <input
                pInputText
                id="email"
                type="email"
                [formControl]="offerForm.controls.email"
                [invalid]="isInvalid('email')"
                class="w-full"
              />
              <label for="email">E-mail *</label>
            </p-floatlabel>

            @if (isError('email'); as error) {
              <p-message severity="error" size="small" variant="simple" class="mt-2 ml-2">
                {{ error }}
              </p-message>
            }

            @if (!offerForm.controls.email.touched || offerForm.controls.email.valid) {
              <small class="mt-2 ml-2 text-secondary-800" id="email-help">To pole jest wymagane</small>
            }
          </div>

          <div class="flex flex-col w-full">
            <p-inputgroup class="w-full">
              <p-inputgroup-addon>
                <span>+48</span>
              </p-inputgroup-addon>

              <p-floatlabel class="w-full">
                <p-inputmask
                  id="phone"
                  mask="999-999-999"
                  [formControl]="offerForm.controls.phone"
                  [invalid]="isInvalid('phone')"
                  class="w-full"
                />
                <label for="phone">Telefon</label>
              </p-floatlabel>
            </p-inputgroup>

            @if (isError('phone'); as error) {
              <p-message severity="error" size="small" variant="simple" class="mt-2 ml-2">
                {{ error }}
              </p-message>
            }
          </div>

          <div class="inline-flex gap-2 items-center w-auto h-auto">
            <p-checkbox
              id="terms"
              [formControl]="offerForm.controls.consentDataProcessing"
              [binary]="true">
            </p-checkbox>
            <span class="text-xs">
                    Mam świadomość, że wysyłając wiadomość za pomocą formularza kontaktowego administrator
                    „Gardocki SA Spółka z ograniczoną odpowiedzialnością" Spółka komandytowa jest uprawniony
                    do przetwarzania moich danych osobowych w uzasadnionym interesie, w szczególności w celu
                    udzielenia odpowiedzi na pytanie, nawiązania kontaktu, przedstawienia oferty, zgodnie z
                    treścią zapytania, w formie telefonicznej lub elektronicznej.
                </span>
          </div>

          @if (isError('consentDataProcessing'); as error) {
            <p-message severity="error" size="small" variant="simple" class="text-xs leading-5">
              {{ error }}
            </p-message>
          }

          @if (!offerForm.controls.consentDataProcessing.touched || offerForm.controls.consentDataProcessing.valid) {
            <small class="text-secondary-800 text-xs leading-5" id="consentDataProcessing-help">To pole jest
              wymagane</small>
          }

          <div class="inline-flex gap-2 items-center w-auto h-auto">
            <p-checkbox
              id="terms"
              [formControl]="offerForm.controls.consentPrivacyPolicy"
              [binary]="true">
            </p-checkbox>
            <span class="text-xs">
                    Zapoznałam/em się z informacją o administratorze danych osobowych
                    <a class="text-primary-500" [href]="privacyPolicyUrl">Polityka prywatności</a>.
                </span>
          </div>

          @if (isError('consentPrivacyPolicy'); as error) {
            <p-message severity="error" size="small" variant="simple" class="text-xs leading-5">
              {{ error }}
            </p-message>
          }

          @if (!offerForm.controls.consentPrivacyPolicy.touched || offerForm.controls.consentPrivacyPolicy.valid) {
            <small class="text-xs leading-5 text-secondary-800" id="consentPrivacyPolicy-help">To pole jest
              wymagane</small>
          }

        </form>
      </div>
    </div>
    <div class="w-full h-auto inline-flex items-center justify-end gap-2 p-5 border-t-1 border-gray-200 ">
      <p-button
        type="submit"
        label="Anuluj"
        [loading]="isProcessing()"
        styleClass="w-full"
        severity="primary"
        [rounded]="true"
        [outlined]="true"
        size="small"
        (click)="onClose()">
      </p-button>
      <p-button
        type="submit"
        label="Wyślij zapytanie"
        [disabled]="offerForm.invalid || isProcessing()"
        [loading]="isProcessing()"
        styleClass="w-full"
        severity="primary"
        [rounded]="true"
        size="small"
        (click)="onSubmit()">
      </p-button>
    </div>
  </ng-template>
</p-dialog>
